import axios from "utilities/axios";
import { AxiosError } from "axios";
import { ISkill } from "redux/modules/setup/setup.types";
import { Url } from "@edgetier/types";

import { useQuery, UseQueryOptions } from "react-query";
import { hotToastOperations } from "utilities-for/toast";

export interface IGetSkillsQueryParameters {
    readonly unrestricted?: boolean;
}

/**
 * Get all skills.
 * @returns Promise of array of skills.
 */
const getSkills = async (url: string, parameters: IGetSkillsQueryParameters) => {
    const { data } = await axios.get<{ items: ISkill[] }>(url, { params: parameters });
    return data.items;
};

/**
 * Hook to get the skills using react query.
 * @param configuration React Query settings.
 */
const useSkills = <T = ISkill[]>(
    parameters: IGetSkillsQueryParameters = {},
    configuration: Omit<UseQueryOptions<ISkill[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    return useQuery<ISkill[], AxiosError, T>([Url.Skills, parameters], () => getSkills(Url.Skills, parameters), {
        onError: (serverError) => hotToastOperations.showServerErrorToast("Skills Request Failed", serverError),
        staleTime: 1000 * 60 * 5,
        ...configuration,
    });
};

export default useSkills;
